import { Row, Col } from 'reactstrap';
import { MdOutlineCheckCircleOutline, MdPhonelinkRing } from "react-icons/md";

const Footer = () => {
    return (
        <div className='mt-5 pt-4' light style={{ backgroundColor: '#124167', color: 'whitesmoke' }}>
            <div className='container py-4'>
                <Row>
                    <Col xs='12' sm='12' md='3' lg='3'>
                        <div className='d-flex'>
                            <h2 className='pt-2 bold'>Al-Nayazak</h2>
                            <img className='mx-2' src="/Assets/2.png" style={{ borderRadius: 50 }} width='50px' height='50px' alt="" />
                        </div>
                        <p>Al-Nayazak reflects our motive to add value in our customers life by providing all required services in their daily and working lives, decrease unemployment from Dubai by hiring in house staff whom we train and give skills.</p>
                    </Col>
                    <Col xs='12' sm='12' md='3' lg='3'>
                        <h2>Our Services</h2>
                        <p>
                            <MdOutlineCheckCircleOutline /> AC Cleaning <br />
                            <MdOutlineCheckCircleOutline /> AC Service <br />
                            <MdOutlineCheckCircleOutline /> AC Repairing <br />
                            <MdOutlineCheckCircleOutline /> AC Painting <br />
                        </p>
                    </Col>
                    <Col xs='12' sm='12' md='3' lg='3'>
                        <h2>24/7 Support</h2>
                        <h6>Call Now: +971501790123</h6>
                        <h6>Location: Dubai, United Arab Emirates</h6>
                    </Col>
                    <Col xs='12' sm='12' md='3' lg='3'>
                        <h2>How We Help You?</h2>
                        <h6>Call Now: +971501790123</h6>
                    </Col>
                </Row>
            </div>
        </div>
    )
};

export default Footer;